import React, { useState, useEffect, useRef } from "react";
import Header from "../../layouts/Employee/Header";
import SubHeader from "../../layouts/Employee/SubHeader";
import Dashboard from "../../layouts/Employee/Dashboard";
import "./AdminEmployeeIndex.css"; 

function AdminEmployeeIndex(props) {
  return (
    <div className='employee-bg'>
      <Header />
      <SubHeader />
      <Dashboard />
    </div>
  );
}

export default AdminEmployeeIndex;
